import { actions, mutations } from '../constants'
import request from '@/utils/request'

const auth = {
  state: {
      recipient:{
        name: '',
        countryName: '',
        countryCode: '',
        phone: '',
      },
      orderItems:[]
  },
  mutations: {
    [mutations.TOPUP_SET_RECIPIENT](state, recipient){
      state.recipient = recipient;
    },
    [mutations.TOPUP_RESET](state){
      state.recipient = {
        name: '',
        countryName: '',
        countryCode: '',
        phone: '',
      };
      state.orderItems = [];
    }
  },
  actions: {
    [actions.TOPUP_SET_RECIPIENT]({commit, state}, recipient){
      commit(mutations.TOPUP_SET_RECIPIENT, recipient);
      return Promise.resolve(recipient);
    },

    [actions.TOPUP_RESET]({commit, state}){
      commit(mutations.TOPUP_RESET);
      return Promise.resolve(true);
    },
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/modules/topup.js